module.exports = " .markdown h1, .markdown h2, .markdown h3, .markdown h4, .markdown h5  {\r\n    font-weight: 900;\r\n    margin: 1.5em  0;\r\n  }\r\n  .markdown p  {\r\n    margin: 1em  0;\r\n  }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/view/view.component.css
// module id = ./src/app/components/view/view.component.css
// module chunks = main